import { Fragment, useEffect, useContext, useRef, useState } from "react"
import { useReactToPrint } from "react-to-print"
import TagPrintBody from "overrides/theme/entelperu/base/components/OrderDetail/TagPrint/TagPrintBody/TagPrintBody"
import { tagPrintContentStyle } from "overrides/theme/entelperu/base/components/OrderDetail/TagPrint/styles/TagPrintContent.style"
import Barcode from "components/Commons/BarCode"
import { formatDate, formatManualTime } from "helpers/FormatDateHelper"
import { useEnv } from "hooks"
import { GlobalContext } from "context/context"
import slotsHelper from "overrides/theme/entel/base/helpers/slots_helper"

const TagPrintButton = ({ shippingGroup, order, user }: any) => {
  const [_client] = useEnv().multiclient.get_user_env()
  const componentRef: any = useRef()
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `tag_${shippingGroup?.salesChannelId}_${Date.now()}`,
  })
  const [show_tag, set_show_tag] = useState<boolean>(false)
  const { state_machine_states, schedules } = useContext(GlobalContext)

  useEffect(() => {
    const currentStatusTag = shippingGroup?._omnixStateMachine?.currentState?.state?.id?.toUpperCase()
    const PICKING_COMPLETED_PENDING_PACKAGE_INDEX = state_machine_states?.state
      ?.map((st: any) => st?.label)
      .indexOf("PICKING_COMPLETED_PENDING_PACKAGE")
    const CURRENT_STATUS_INDEX = state_machine_states?.state?.map((st: any) => st?.label).indexOf(currentStatusTag)
    if (CURRENT_STATUS_INDEX >= PICKING_COMPLETED_PENDING_PACKAGE_INDEX) {
      set_show_tag(true)
    }
    if (currentStatusTag === "DELIVER_TO_COURIER" || currentStatusTag === "DELIVERED_TO_COURIER") {
      set_show_tag(true)
    }
    // eslint-disable-next-line
  }, [shippingGroup])

  const address_peru = `${shippingGroup?.shippingAddress?.addressName || ""} ${
    shippingGroup?.shippingAddress?.addressNumber || ""
  } - ${shippingGroup?.shippingAddress?.addressNumberComplement || ""} ${shippingGroup?.shippingAddress?.zone || ""} ${
    shippingGroup?.shippingAddress?.block || ""
  } ${shippingGroup?.shippingAddress?.lot || ""}, ${shippingGroup?.shippingAddress?.commune || ""}`

  const address_chile = `${shippingGroup?.shippingAddress?.addressName || ""} ${
    shippingGroup?.shippingAddress?.addressNumber || ""
  } - ${shippingGroup?.shippingAddress?.addressNumberComplement || ""}, ${
    shippingGroup?.shippingAddress?.commune || ""
  }`

  const _slotDelivery = slotsHelper(schedules?.state, shippingGroup)

  const data = {
    numberGuide: shippingGroup?.salesChannelId,
    from: `Entel ${shippingGroup?.source?.name || ""}`,
    parent: "Entel",
    to: shippingGroup?.customer?.name,
    deliveryType: shippingGroup?.deliveryType,
    address: _client === "entelperu" ? address_peru : address_chile,
    notes: "-",
    phone: `${shippingGroup?.customer?.phone || ""} ${
      shippingGroup?.customer?.phone2 ? `, ${shippingGroup?.customer?.phone2}` : ""
    }`,
    date: `${formatDate(shippingGroup?.estimatedDeliveryDate, "yyyy-MM-dd")} ${
      formatManualTime(_slotDelivery?.initial) + " - " + formatManualTime(_slotDelivery?.final)
    }`,
  }

  return show_tag ? (
    <Fragment>
      <div style={{ display: "none" }}>
        <TagPrintBody ref={componentRef} data={data} />
      </div>
      <div className="pt__app-container">
        <div className="pt__tag__left-info">
          <h4>Etiqueta de impresión</h4>
        </div>
        <div className="pt__print-tag__barcode">
          <Barcode showSvg value={shippingGroup?.salesChannelId} height={80} />
          <button className="pt__button_print_tag" onClick={handlePrint}>
            Imprimir
          </button>
        </div>
      </div>
      <style jsx>{tagPrintContentStyle}</style>
    </Fragment>
  ) : null
}

export default TagPrintButton
